module.exports = __webpack_public_path__ + "images/emoji/nail_care.6c4c257ecb4b81bdae60.png";